// FEN utilities that bypass chess.js validation.

export function parseFen(fen) {
  const parts = (fen || '').split(' ');
  return {
    placement: parts[0] || '8/8/8/8/8/8/8/8',
    turn: parts[1] || 'w',
    castling: parts[2] || '-',
    enPassant: parts[3] || '-',
    halfmove: parts[4] || '0',
    fullmove: parts[5] || '1',
  };
}

export function placementToBoard(placement) {
  return placement.split('/').map(row => {
    const arr = [];
    for (const ch of row) {
      if (/\d/.test(ch)) {
        for (let i = 0; i < parseInt(ch, 10); i++) arr.push('');
      } else arr.push(ch);
    }
    return arr;
  });
}

export function boardToPlacement(board) {
  return board.map(row => {
    let out = '', empty = 0;
    for (const c of row) {
      if (c === '') empty++;
      else {
        if (empty) { out += empty; empty = 0; }
        out += c;
      }
    }
    if (empty) out += empty;
    return out;
  }).join('/');
}

function squareToIdx(sq) {
  const file = sq.charCodeAt(0) - 'a'.charCodeAt(0);
  const rank = 8 - parseInt(sq[1], 10);
  return { file, rank };
}

// Move any piece to any square, no validation. Optionally keep turn same to allow multiple moves.
export function applyIllegalMove(fen, from, to, keepTurn = true) {
  const parts = parseFen(fen);
  const board = placementToBoard(parts.placement);
  const f = squareToIdx(from);
  const t = squareToIdx(to);
  const piece = board[f.rank][f.file];
  if (!piece) return null;
  board[f.rank][f.file] = '';
  board[t.rank][t.file] = piece;
  const newPlacement = boardToPlacement(board);
  const nextTurn = keepTurn ? parts.turn : (parts.turn === 'w' ? 'b' : 'w');
  return `${newPlacement} ${nextTurn} - - 0 ${parts.fullmove}`;
}

export function setSquare(fen, square, piece /* 'K','q','' */) {
  const parts = parseFen(fen);
  const board = placementToBoard(parts.placement);
  const s = squareToIdx(square);
  board[s.rank][s.file] = piece;
  const newPlacement = boardToPlacement(board);
  return `${newPlacement} ${parts.turn} ${parts.castling} ${parts.enPassant} ${parts.halfmove} ${parts.fullmove}`;
}

export const EMPTY_FEN = '8/8/8/8/8/8/8/8 w - - 0 1';
export const STARTING_FEN = 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1';

// ---- Chess sound wrappers ----
// The actual WebAudio synthesizers live in /lib/chessSounds.js (single
// source of truth). These names are preserved as thin re-exports so every
// callsite (ChessBoardView, existing imports, etc.) keeps working without
// churn — kills the risk of a partial migration.
import { playChessMoveSound, playChessCaptureSound } from './chessSounds';
export const playMoveSound    = playChessMoveSound;
export const playCaptureSound = playChessCaptureSound;
